import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { PasteFromClipboardContent } from './pasteFromClipboardContent/PasteFromClipboardContent'

interface IProps {
  show: boolean
  onClose: () => void
}

export const PasteFromClipboard = ({ show, onClose }: IProps) => {
  const contentProps = useMemo(
    () => ({
      onClose,
    }),
    [onClose]
  )
  return (
    <ModalDialog
      onClose={onClose}
      show={show}
      size={'xs'}
      content={PasteFromClipboardContent}
      contentProps={contentProps}
    />
  )
}
